export const palette = [
  { name: 'Marfil cálido', hex: '#F6F2EA', use: 'Fondo principal de la página.' },
  { name: 'Blanco', hex: '#FFFFFF', use: 'Superficies elevadas: presentación del libro y oferta.' },
  { name: 'Negro carbón', hex: '#171717', use: 'Titulares, texto principal y botón de compra.' },
  { name: 'Gris cálido', hex: '#69655F', use: 'Texto secundario y notas.' },
  { name: 'Amarillo dorado', hex: '#E8B923', use: 'Solo acento: filetes, marcas y detalles. Nunca como fondo de sección.' },
  { name: 'Dorado tinta', hex: '#7A5C00', use: 'Refinamiento: versión legible del dorado para texto sobre marfil (contraste AA).' },
  { name: 'Arena', hex: '#E3DCCD', use: 'Líneas divisorias y bordes suaves.' },
]

export const typography = [
  {
    family: 'Newsreader',
    role: 'Editorial · titulares',
    sample: 'Nos falta atrevernos a comenzar.',
    notes: 'Serif de lectura con itálica expresiva. Peso 400–500, minúsculas, interlineado 1.1.',
    className: 'font-serif text-3xl leading-tight',
  },
  {
    family: 'Inter',
    role: 'Sans · texto e interfaz',
    sample: 'PDF digital · Descarga por correo electrónico',
    notes: 'Cuerpo de 16–18 px, interlineado 1.6. Botones en 500–600 sin mayúsculas forzadas.',
    className: 'font-sans text-lg',
  },
]

export const principles = [
  {
    title: 'La pregunta antes que la oferta',
    body: 'El hero abre con una pregunta humana y el mockup como protagonista. El precio aparece una sola vez, en el momento de la invitación.',
  },
  {
    title: 'Un acento, no un grito',
    body: 'El dorado aparece en menos del 5 % de la superficie. El contraste lo aporta el carbón sobre marfil.',
  },
  {
    title: 'Pocas palabras, mucho aire',
    body: 'Bloques de texto de 2 a 4 líneas en móvil, máximo 60 caracteres por línea en escritorio.',
  },
  {
    title: 'Un solo llamado a la acción',
    body: '«Quiero leer este libro» es el único CTA. En móvil, una barra discreta lo acompaña entre secciones y desaparece al llegar a la oferta.',
  },
  {
    title: 'Movimiento casi invisible',
    body: 'Solo una entrada suave en el hero, el acordeón y la barra móvil. Todo bajo 300 ms y respetando «reducir movimiento».',
  },
]

export const shopifyMapping = [
  {
    section: 'Plantilla independiente',
    native: 'Nativo',
    how: 'Tienda online › Personalizar › Productos › Crear plantilla (p. ej. «libro-verguenza»). Asignarla solo a este producto. El resto de la tienda no cambia.',
  },
  {
    section: 'Colores de la página',
    native: 'Nativo',
    how: 'Crear un esquema de color nuevo (marfil, carbón, dorado) en Ajustes del tema y aplicarlo solo a las secciones de esta plantilla.',
  },
  {
    section: '1 · Conexión emocional',
    native: 'Nativo',
    how: 'Sección de medios con contenido: mockup aprobado + titular + texto. Sin bloque de precio ni botón.',
  },
  {
    section: '2 · Identificación',
    native: 'Nativo',
    how: 'Medios con contenido con la imagen a la izquierda y bloques de texto.',
  },
  {
    section: '3 · Presentación del libro',
    native: 'Nativo + CSS opcional',
    how: 'Sección con grupo de bloques de texto. La tarjeta «pobreza de espíritu» es un grupo con fondo blanco y borde; el filete dorado requiere CSS personalizado.',
  },
  {
    section: '4 · RESET 21',
    native: 'Nativo',
    how: 'Medios con contenido con la foto aprobada. Los tres datos, en un grupo horizontal de bloques de texto.',
  },
  {
    section: '5 · Invitación a comprar',
    native: 'Nativo',
    how: 'Bloques de la información del producto: Precio, Botones de compra y Texto. El checkout es el nativo de Shopify; desactivar el botón de pago dinámico para mantener un solo CTA.',
  },
  {
    section: '6 · Preguntas frecuentes',
    native: 'Nativo',
    how: 'Bloque de acordeón / contenido desplegable con las tres preguntas.',
  },
  {
    section: 'Barra de compra fija en móvil',
    native: 'Código personalizado',
    how: 'Verificar si tu versión de Horizon incluye barra fija de compra. Si no, sección Liquid personalizado (HTML + CSS + JS ligero) cargada solo en esta plantilla.',
  },
  {
    section: 'Tipografía Newsreader',
    native: 'Código personalizado',
    how: 'Si no aparece en la biblioteca de fuentes de Shopify, cargarla desde Liquid personalizado, solo en esta plantilla. Inter está disponible de forma nativa.',
  },
]
